var map = {
	"./100 Acres Club - 304_176.webp": 7683,
	"./98.3 Radio Mirchi - 304_176.webp": 7443,
	"./APAC - 304_176.webp": 1273,
	"./Abbott - 304_176.webp": 9456,
	"./Accely - 304_176.webp": 2611,
	"./Accenture - 304_176.webp": 9674,
	"./Aeonx Digital - 304_176.webp": 1099,
	"./Anant Zaveri - 304_176.webp": 2357,
	"./Argencia Silver - 304_176.webp": 8381,
	"./Astral Pipes - 304_176.webp": 9086,
	"./Atul Ltd - 304_176.webp": 2364,
	"./Bajaj Finserv - 304_176.webp": 8981,
	"./Belvedere - 304_176.webp": 6590,
	"./Brainvire - 304_176.webp": 386,
	"./Chiripal Group  - 304_176.webp": 6947,
	"./DCB Bank - 304_176.webp": 2057,
	"./Delhivery - 304_176.webp": 3076,
	"./Dell - 304_176.webp": 1327,
	"./Dhootpapeshwar - 304_176.webp": 49,
	"./Euro Jyoti - 304_176.webp": 6612,
	"./Exide Industries - 304_176.webp": 8027,
	"./Food and Agriculture Organization - 304_176.webp": 5061,
	"./Forever Living - 304_176.webp": 4268,
	"./GCCI - 304_176.webp": 8262,
	"./Gihed Credai - 304_176.webp": 3821,
	"./Gulab Oil - 304_176.webp": 8593,
	"./Haikawa - 304_176.webp": 6048,
	"./Hearmo - 304_176.webp": 1564,
	"./Hexagon - 304_176.webp": 5318,
	"./ICICI Bank - 304_176.webp": 1539,
	"./IIM Ahmedabad - 304_176.webp": 1424,
	"./IIT - 304_176.webp": 2732,
	"./JK Securities - 304_176.webp": 1313,
	"./Juggernaut - 304_176.webp": 5296,
	"./KEC - 304_176.webp": 8467,
	"./Khadhya Khurak - 304_176.webp": 8276,
	"./LCC - 304_176.webp": 5428,
	"./Livespace - 304_176.webp": 5710,
	"./Orra Fine Jewellery - 304_176.webp": 863,
	"./Panasonic - 304_176.webp": 2900,
	"./Religare - 304_176.webp": 3627,
	"./SAS - 304_176.webp": 6975,
	"./SBS - 304_176.webp": 432,
	"./SPCT Club - 304_176.webp": 9026,
	"./Saraspur Nagarik Co Op Bank - 304_176.webp": 4815,
	"./Sarjen Systems - 304_176.webp": 6285,
	"./Shapoorji Pallonji - 304_176.webp": 4742,
	"./Sika - 304_176.webp": 3084,
	"./Skyhigh Security - 304_176.webp": 8309,
	"./TATA IIS - 304_176.webp": 3079,
	"./TEDx IIT - 304_176.webp": 6485,
	"./Taj Gandhinagar - 304_176.webp": 467,
	"./Ultra Tech Cement - 304_176.webp": 6352,
	"./Vasant Masala - 304_176.webp": 3302,
	"./aibi - 304_176.webp": 2451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2565;